import React from "react";

import "./footer.styles.scss";
import { getYear } from "utils/common-helper";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer_major row pt-5">
          <div className="col-lg-4 col-md-6">
            <span>Services</span>
            <ul className="mt-3">
              <li>Social Media Management</li>
              <li>Web Design & Development</li>
              <li>SEO & SEM</li>
              <li>Graphic Design</li>
              <li>Branding and Content Marketing</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <span>Utilities</span>
            <ul className="mt-3">
              <li>Our Blogs</li>
              <li>Our Works</li>
              <li>About</li>
              <li>Contact</li>
              <li>Career</li>
            </ul>
          </div>

          <div className="col-md-2">
            <span>Legal</span>
            <ul className="mt-3">
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
            </ul>
          </div>
        </div>

        <div className="footer_minor my-5">
          <hr />
          <div className="mt-4 d-flex justify-content-between">
            <div className="copyright">
              Copyright © {getYear} Brandspire Creatives
            </div>
            <div className="social-links">
              <i className="fa-brands fa-facebook" aria-hidden="true"></i>
              <i className="fa-brands fa-instagram" aria-hidden="true"></i>
              <i className="fa-brands fa-youtube"></i>
              <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
              <i className="fa-brands fa-twitter" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
